<chd-navigation-menu-material-renderer />
<spa-backend-toggle [labelAboveToggle]="true" />
